import { useState } from "react";
import { api, formatApiError } from "../api/client";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { toast } from "sonner";

const TYPES = [
  { value: "policy", label: "Política" },
  { value: "procedure", label: "Procedimiento" },
  { value: "record", label: "Registro" },
  { value: "plan", label: "Plan" },
];

export default function NewBlankModal({ open, onClose, onCreated }) {
  const [title, setTitle] = useState("");
  const [type, setType] = useState("policy");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!title.trim()) return toast.error("Indica un título.");
    setBusy(true);
    try {
      const { data } = await api.post("/documents", { title: title.trim(), type, related_controls: [] });
      toast.success("Documento creado.");
      onCreated(data);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="modal-new-blank">
        <DialogHeader><DialogTitle>Nuevo documento en blanco</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Título</Label>
            <Input data-testid="blank-title" value={title} onChange={(e) => setTitle(e.target.value)} />
          </div>
          <div>
            <Label>Tipo</Label>
            <Select value={type} onValueChange={setType}>
              <SelectTrigger data-testid="blank-type"><SelectValue /></SelectTrigger>
              <SelectContent>{TYPES.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancelar</Button>
          <Button onClick={submit} disabled={busy} data-testid="blank-submit">{busy ? "Creando..." : "Crear"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
